import {MODAL_ACTION} from '../actions/ModalActions';
import findKey from 'lodash/findKey';
import isNil from 'lodash/isNil';

export const hasOpenModal = (state) => {
    return !isNil(findKey(state));
};

export function modals(state = {}, action) {
    switch (action.type) {
        case MODAL_ACTION: {
            const {name, open} = action;
            return {...state, [name]: open};
        }
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/modals.js